var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lc-switch"},[_c('el-switch',{attrs:{"active-value":_vm.activeValue,"inactive-value":_vm.inactiveValue,"disabled":_vm.disabled},model:{value:(_vm.switchValue),callback:function ($$v) {_vm.switchValue=$$v},expression:"switchValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }